import { orderBy } from 'lodash'

import { LearningItem } from '../../models/LearningItem'

export default function finishedLearningItems(userLearningItems: LearningItem[]) {
  return userLearningItems
    .filter((learningItem) => learningItem.learningProgress?.completedAt)
    .map((learningItem) => ({
      learningItem,
      assignment: orderBy(
        learningItem.userLearningAssignments || [],
        [
          ({ dueDate }) => (dueDate ? dueDate.toISOString() : ''),
          ({ createdAt }) => (createdAt ? createdAt.toISOString() : ''),
        ],
        ['desc', 'desc']
      )[0] as Exclude<LearningItem['userLearningAssignments'], null | undefined>[number] | undefined,
    }))
}
